import $ from 'jquery';

function Revealer(selector) {
  var self = this;
  $(selector).find('.js-revealable').each(function () {
    var $this = $(this);
    $this.on('click', '.js-reveal-item', function (e) {
      e.preventDefault();
      self.showMoreItems($this);
    });
  });
}

Revealer.prototype.showMoreItems = function (selector) {
  var hidden = $(selector).find('.is-hidden');
  hidden.slice(0, 3).removeClass('is-hidden');
  var num_hidden = $(selector).find('.is-hidden').size();
  var num_total = $(selector).find('.js-total-number').text();
  $(selector).find('.js-revealed-number').text(num_total - num_hidden);
  if(num_hidden == 0) $(selector).find('.js-reveal-item').addClass('is-hidden');
};

export default Revealer;
